import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Routes from "./routes/routesAdm";

import history from "./services/history";

import { AuthProvider } from "./config/AuthContext";

// Fontes
import "@fontsource/montserrat";
import "@fontsource/inter";
import "@fontsource/abhaya-libre";
import { FaturamentoProvider } from "../src/pages/Faturamento/FaturamentoContext";

function App() {
  const limpaCache = () => {
    const hasReload = localStorage.getItem("reload");
    if (!hasReload) {
      localStorage.setItem("reload", true);
      window.location.reload(true);
    }
  };
  useEffect(() => {
    // limpaCache();
  }, []);
  return (
    <AuthProvider>
      <FaturamentoProvider>
        <Router navigator={history} location={history.location}>
          <Routes />
        </Router>
      </FaturamentoProvider>
    </AuthProvider>
  );
}

export default App;
